var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMediaInIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 0.496094H2.19922C1.09922 0.496094 0.199219 1.39609 0.199219 2.49609V18.4961C0.199219 19.5961 1.09922 20.4961 2.19922 20.4961H18.1992C19.2992 20.4961 20.1992 19.5961 20.1992 18.4961V2.49609C20.1992 1.39609 19.2992 0.496094 18.1992 0.496094ZM6.19922 17.4961H3.19922V8.49609H6.19922V17.4961ZM4.69922 6.79609C3.69922 6.79609 2.89922 5.99609 2.89922 4.99609C2.89922 3.99609 3.69922 3.19609 4.69922 3.19609C5.69922 3.19609 6.49922 3.99609 6.49922 4.99609C6.49922 5.99609 5.69922 6.79609 4.69922 6.79609ZM17.1992 17.4961H14.1992V12.1961C14.1992 11.3961 13.4992 10.6961 12.6992 10.6961C11.8992 10.6961 11.1992 11.3961 11.1992 12.1961V17.4961H8.19922V8.49609H11.1992V9.69609C11.6992 8.89609 12.7992 8.29609 13.6992 8.29609C15.5992 8.29609 17.1992 9.89609 17.1992 11.7961V17.4961Z",
    fill: "#57769c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaInIconBlue);
export default __webpack_public_path__ + "static/media/social-media-in-icon-blue.618dbab736d4aee1a8d15d42c8d616a4.svg";
export { ForwardRef as ReactComponent };